import React from 'react';
import { Bookmark, BookmarkActionHandlers } from '../shared/types';
import { BookmarkCard } from '../shared/BookmarkCard';

interface CardLayoutProps {
  bookmarks: Bookmark[];
  handlers: BookmarkActionHandlers;
}

export const CardLayout: React.FC<CardLayoutProps> = ({ bookmarks, handlers }) => {
  return (
    <div className="bookmarks-grid">
      {bookmarks.map(bookmark => (
        <BookmarkCard
          key={bookmark.id}
          bookmark={bookmark}
          handlers={handlers}
          isGrouped={false}
        />
      ))}
    </div>
  );
};